import React from 'react';
import {Fade} from '@mui/material';
import {closeSnackbar, SnackbarProvider, SnackbarProviderProps} from 'notistack';

document.body.addEventListener('click', () => closeSnackbar());

export const LLNotistackSnackbarProvider = (props: SnackbarProviderProps) => {
	const {children, ...rest} = props;
	
	return (
		<SnackbarProvider
			anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}
			TransitionComponent={Fade}
			preventDuplicate={true}
			{...rest}
		>
			{children}
		</SnackbarProvider>
	);
};

export default LLNotistackSnackbarProvider;
